import { createContext, useReducer } from "react";

/**
 * Use Context and Use Reducer
 *
 * The Context allows us to create something global that can be accessed all over the application or the component
 * The contect also gives use the provider which provides the data needed
 *
 * The useReducer is like a useState but with a dispatch(setState) and the Reducer function
 *
 * Inside the dispatch, we pass {type:'ACTION to be done', payload:[Data to be set]}
 *
 * The reducer function takes a state(The initial state) and the action which is the dispatch(type,payload)
 *
 * Finally we pass the state and disptach to the Provider as a value object
 */
export const ProjectsContext = createContext();

export const projectsReducer = (state, action) => {
  switch (action.type) {
    case "GET_PROJECTS":
      return {
        projects: action.payload,
      };
    case "ADD_PROJECT":
      return {
        /**
         * action.payload => New project
         * state.projects => Contains the previous projects
         * ...state.proggrammes => Spread the previous projects
         */
        projects: [action.payload, ...state.projects],
      };
    case "DELETE_PROJECT":
      return {
        /**
         * action.payload => New project
         * state.projects => Contains the previous projects
         * ...state.projects => Spread the previous projects
         *
         * Since payload for this has only the id, then we use the id to filter
         */
        projects: state.projects.filter(
          (project) => project.id !== action.payload
        ),
      };
    case "EDIT_PROJECT":
      return {
        // ...state,
        projects: state.projects.map((project) =>
          project.id === action.payload.id ? action.payload : project
        ),
      };

    default:
      return state;
  }
};

export const ProjectsContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(projectsReducer, {
    projects: null,
  });

  return (
    <ProjectsContext.Provider value={{ ...state, dispatch }}>
      {children}
    </ProjectsContext.Provider>
  );
};
